import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LeadPipelineResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                columns: [
                    {
                        stage: 'NEW',
                        manually_reachable_stages: ['CONTACTED', 'NEGOTIATION', 'PRODUCT_TRIAL', 'STAND_BY'],
                        leads: [{
                            id: 'b7f0c2de-5a3e-4c1a-9a4e-3f6f1f0d2a11',
                            fantasy_name: "Michael's Bakery",
                            phone: '1122334455',
                            email: 'michael@dundermifflin.com',
                            origin_channel: 'WhatsApp',
                            how_they_knew_us: 'Meta',
                            referral_observation: '',
                            commerce_type: 'Panadería',
                            commerce_type_specification: '',
                            interest_products: ['Panes'],
                            commercial_channel: 'Horeca',
                            business_name: 'Dunder Mifflin',
                            taxpayer_identification_number: '30712345678',
                            belongs_to_a_disabled_customer: false,
                            is_possible_duplicate: false,
                            franchise_brand_name: null,
                            creation_datetime: '2026-10-17T14:30:00-03:00',
                            stage: 'NEW',
                            has_responsible: true,
                            responsible: 'closer@saporedipane.com',
                            lead_delivery_sites: [],
                            responsible_name: 'Jim Halpert',
                            pipeline_entry_datetime: '2026-10-19T09:00:00-03:00',
                            days_in_current_stage: 3,
                        }],
                    },
                    {
                        stage: 'CLOSED',
                        manually_reachable_stages: [],
                        leads: [],
                    },
                ],
            },
            errors: [],
        };
    }

    columns() {
        return this.content().columns.map((column) => ({
            stage: column.stage,
            manuallyReachableStages: column.manually_reachable_stages,
            leads: column.leads.map((lead) => ({
                id: lead.id,
                fantasyName: lead.fantasy_name,
                responsibleName: lead.responsible_name,
                commercialChannel: lead.commercial_channel,
                daysInCurrentStage: lead.days_in_current_stage,
            })),
        }));
    }
}
